import { c as _c } from "react/compiler-runtime";
import { Minus, Plus } from '@byway/icons';
import { Field, type FieldProps } from 'formik';
import type { HTMLAttributes } from 'react';
import { FormErrorMessage } from './FormErrorMessage';
type NumberInputProps = HTMLAttributes<HTMLInputElement> & {
  name: string;
  label?: string;
  min?: number;
  max?: number;
  placeholder?: string;
  required?: boolean;
  showErrors?: boolean;
};
function NumberInput(t0) {
  const $ = _c(21);
  let name;
  let props;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  if ($[0] !== t0) {
    ({
      name,
      label: t1,
      placeholder: t2,
      min: t3,
      max: t4,
      required: t5,
      showErrors: t6,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = name;
    $[2] = props;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
    $[7] = t5;
    $[8] = t6;
  } else {
    name = $[1];
    props = $[2];
    t1 = $[3];
    t2 = $[4];
    t3 = $[5];
    t4 = $[6];
    t5 = $[7];
    t6 = $[8];
  }
  const label = t1 === undefined ? "" : t1;
  const placeholder = t2 === undefined ? "" : t2;
  const min = t3 === undefined ? 0 : t3;
  const max = t4 === undefined ? Number.MAX_SAFE_INTEGER : t4;
  const required = t5 === undefined ? false : t5;
  const showErrors = t6 === undefined ? false : t6;
  let t7;
  if ($[9] !== label || $[10] !== max || $[11] !== min || $[12] !== name || $[13] !== placeholder || $[14] !== props || $[15] !== required || $[16] !== showErrors) {
    t7 = t8 => {
      const {
        field,
        form: t9
      } = t8;
      const {
        setFieldValue,
        setFieldTouched
      } = t9;
      return <div className="mb-4">{label && <label htmlFor={name} className="text-black">{label}{required && <span className="text-status-error"> *</span>}</label>}{showErrors && <FormErrorMessage name={name} />}<div className="flex mt-1"><div className="flex w-full rounded-md md:max-w-xs"><button type="button" className="inline-flex items-center px-3 text-xl rounded-l-md border border-r-0 cursor-pointer text-neutral-500 border-neutral-300 bg-neutral-100" data-testid="decrease-button" onClick={() => {
              setFieldValue(name, Math.max(min, Number.isNaN(field.value) ? 0 : field.value - 1));
              setFieldTouched(name, true);
            }}><Minus ariaLabel="Reduce" size="large" /></button><input type="tel" placeholder={placeholder} readOnly={true} className="block flex-1 p-2 w-full text-center rounded-none border border-neutral-300 focus:ring-primary-500 focus:border-primary-500 typography-emphasis-2" {...field} {...props} /><button type="button" className="inline-flex items-center px-3 text-xl rounded-r-md border border-l-0 cursor-pointer text-neutral-500 border-neutral-300 bg-neutral-100" data-testid="increase-button" onClick={() => {
              setFieldValue(name, Math.min(max || Number.MAX_SAFE_INTEGER, Number.isNaN(field.value) ? 1 : field.value + 1));
              setFieldTouched(name, true);
            }}><Plus ariaLabel="Increase" size="large" /></button></div></div></div>;
    };
    $[9] = label;
    $[10] = max;
    $[11] = min;
    $[12] = name;
    $[13] = placeholder;
    $[14] = props;
    $[15] = required;
    $[16] = showErrors;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== name || $[19] !== t7) {
    t8 = <Field name={name}>{t7}</Field>;
    $[18] = name;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  return t8;
}
export { NumberInput };